import { TOP_LEVEL_ROUTES } from './routes';

// Resouces Pages Only
// Can be refactored to include JON or other pages,
// Or JON and other page groups may implement their own helpers
export const isFitness = groupPageId =>
	groupPageId.toLowerCase().includes('fitness');

export const isMembers = groupPageId =>
	groupPageId.toLowerCase().includes('members');

export const isProvider = groupPageId =>
	groupPageId && !isFitness(groupPageId) && !isMembers(groupPageId);

export const getResourceHeader = groupPageId => {
	if (isFitness(groupPageId))
		return {
			link: `/${TOP_LEVEL_ROUTES.resources}/fitness`,
			text: 'Resources - Fitness Centers',
		};
	if (isMembers(groupPageId))
		return {
			link: `/${TOP_LEVEL_ROUTES.resources}/members`,
			text: 'Resources - Members',
		};
	return {
		link: `/${TOP_LEVEL_ROUTES.resources}/providers`,
		text: 'Resources - Providers',
	};
};
